import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryNav() {
  return (
    <section className="py-8 md:py-10 bg-background-100" aria-label="内容分类">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-50 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500">
                  {cat.count.toLocaleString()}+ 部
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}